import { render, staticRenderFns } from "./Parent.vue?vue&type=template&id=cbcea5cc&scoped=true&"
import script from "./Parent.vue?vue&type=script&lang=js&"
export * from "./Parent.vue?vue&type=script&lang=js&"
import style0 from "./Parent.vue?vue&type=style&index=0&id=cbcea5cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcea5cc",
  null
  
)

export default component.exports